export default __webpack_public_path__ + "static/media/129.226bc60e.jpg";